import React from "react";
import cssClasses from "./AuthSuccess.module.css";

const authSuccess = (props) => {
    return (<div className={cssClasses.AuthSuccess}>
        <p style={{ font: "normal normal bold 16px/18px Arial", margin: "0 0 0 0 ", alignSelf: "center" }}>{props.authSuccess}</p>
    </div>);
}

export default authSuccess;